<script setup>
// Root component. Routing (incl. the auth-gate guard) lives in @/router.
import CookieNotice from "@/components/CookieNotice.vue";
</script>

<template>
  <RouterView />
  <CookieNotice />
</template>
